import { render, staticRenderFns } from "./ReporteTrazabilidad.vue?vue&type=template&id=036167ec&scoped=true&"
import script from "./ReporteTrazabilidad.vue?vue&type=script&lang=js&"
export * from "./ReporteTrazabilidad.vue?vue&type=script&lang=js&"
import style0 from "./ReporteTrazabilidad.vue?vue&type=style&index=0&id=036167ec&scoped=true&lang=css&"
import style1 from "./ReporteTrazabilidad.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036167ec",
  null
  
)

export default component.exports